// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3nYy6","left":"styles_left__1cW9Q"};